export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 bg-background-200 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20clean%20minimal%20smartphone%20screen%20mockup%20showing%20a%20video%20streaming%20app%20interface%20with%20warm%20amber%20and%20cream%20color%20scheme%2C%20modern%20UI%20design%2C%20soft%20lighting%2C%20clean%20composition%2C%20professional%20product%20photography%20style%2C%20minimal%20aesthetic&width=448&height=448&seq=app-mockup-01&orientation=squarish"
              alt="海角网移动端 - 随时随地免费看"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">
              移动观看
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              海角网全面适配手机与平板设备，支持投屏到电视大屏观看。随时随地打开海角网免费看，通勤路上、午休时间、睡前片刻，海量免费视频资源随身相伴。移动端还独家支持离线缓存功能，无网络也能畅享海角在线观看免费体验。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-md text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line"></i>
                iOS 版下载
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-md text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-android-line"></i>
                Android 版下载
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}